<template>
  <v-dialog :value="isShow" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển quản lý lớp
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển quản lý lớp"
              >
                <common-select-user
                  v-model="gvcn"
                  :items="listGVCNV2"
                  color="primary"
                  item-text="name"
                  placeholder="Tìm kiếm quản lý lớp theo tên"
                  :item-value="(item) => item"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 px-4 w-full d-flex justify-end">
          <div class="d-flex justify-space-between" style="width:27%">
            <v-btn class="cancel-button" @click="hideModal">Hủy bỏ</v-btn>
            <v-spacer />
            <v-btn class="update-button" @click.prevent="handleSubmit(saveChange)">Xác nhận</v-btn>
          </div>
        </v-card-actions>
      </validation-observer>
       <v-dialog :value="showModal" max-width="1000" persistent>
        <confirm-change-teacher :commonTeacher="commonTeacher" :gvcn="gvcn" :selectionData="selectionData" @close="showModal=false" @done="closeChange()" />
       </v-dialog>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import TokenService from '../../../helpers/token';
import BlendedCareServices from '../../../services/BlendedCareRepository';
import ConfirmChangeTeacher from './ConfirmChangeTeacher.vue';

export default {
  components: { ConfirmChangeTeacher },
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      gvcn: {},
      userId: null,
      commonTeacher: {},
      selectionData: {},
    };
  },
  created() {
    const dataUser = TokenService.getUser() || {};
    this.userId = _.get(dataUser, 'id', '');
    this.getListGVCN();
    this.getListGVCNV2();
    this.getListTotalGVCN();
  },
  computed: {
    ...mapState('student_care', ['listGVCN', 'listGVCNV2']),
    ...mapState('blended', ['dataBlendedTutor']),
  },
  methods: {
    ...mapActions('student_care', ['getListGVCN', 'getListTotalGVCN', 'getListGVCNV2']),
    hideModal() {
      this.$emit('close-modal-add-head-teacher', false);
      this.errorMessage = '';
      this.userId = '';
    },
    async saveChange() {
      if (this.dataBlendedTutor && this.dataBlendedTutor.length > 0) {
        const listSelectedId = [];
        this.dataBlendedTutor.forEach(
          (contact) => {
            if (contact.checkbox) {
              listSelectedId.push(contact.id);
            }
          },
        );
        if (listSelectedId.length === 0) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn khách hàng !!!',
          });
        }

        if (!this.gvcn.id || !this.gvcn.name) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn Quản lý lớp !!!',
          });
        }
        this.selectionData = { ids: listSelectedId, userId: this.gvcn.id };
        // Disable check trùng gvcn
        // const result = await BlendedCareServices.getListCommonTeacherByStudentPhone({ ids: listSelectedId, userId: this.gvcn.id });
        // if (result && result.data) {
        //   this.commonTeacher = result.data;
        //   this.showModal = true;
        // } else {
        //   this.commonTeacher = {};
        //   this.showModal = true;
        // }
        const loading = this.$loading.show();
        const result = await BlendedCareServices.updateTeacher({
          ids: this.selectionData.ids,
          teacherId: this.selectionData.userId,
        });
        loading.hide();
        if (result && result.message === 'Success') {
          this.$swal({
            type: 'success',
            title: 'Thành công',
            text: 'Chuyển quản lý lớp thành công!!!',
          });
          this.closeChange();
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: `Có lỗi khi chuyển quản lý lớp: ${result.message} !!!`,
          });
        }
      }

      return true;
    },
    closeChange() {
      Bus.$emit('reload-page-blended');
      this.hideModal();
    },
  },
};
</script>
<style scoped>
.w-full {
  width: 100%;
}
.update-button {
  background-color: #fd1f6d !important;
  color: white;
}
.cancel-button {
  background: #BDBDBD !important;
  color: white;
}
</style>
